import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from 'react-i18next';
import { Heading2 } from '../design-system/headings';
import { AnswerableRadioButton } from './radio-button';
import { isHighlightOnlyAnswer } from './answer-highlight';

export const DecisionAnswers = observer(({ ui, answer }) => {
    const { t } = useTranslation('assessment');

    return (
        <div className="section-exam">
            <div className={classes('assessment')}>
                {Object.keys(ui.decisions)
                    .sort(
                        (a, b) => ui.decisions[a].order - ui.decisions[b].order
                    )
                    .map((decisionKey, i) => {
                        const highlightOnly = isHighlightOnlyAnswer(answer);
                        const showDecision = highlightOnly
                            ? answer?.correctAnswer?.[decisionKey]
                            : answer?.userAnswer?.[decisionKey];

                        return (
                            showDecision && (
                                <>
                                    {i > 0 && (
                                        <>
                                            <br />
                                            <br />
                                        </>
                                    )}
                                    <div className={'assessment-question'}>
                                        <Heading2 bold>
                                            {t(
                                                ui.decisions[decisionKey]
                                                    .question
                                            )}
                                        </Heading2>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                aria-label="email"
                                                name="email"
                                                value={''}
                                            >
                                                {ui.decisions[
                                                    decisionKey
                                                ].options.map(
                                                    (decisionOption, i) => {
                                                        return (
                                                            <AnswerableRadioButton
                                                                key={
                                                                    'radio-' + i
                                                                }
                                                                groupValue={
                                                                    'value'
                                                                }
                                                                value={
                                                                    decisionOption.value
                                                                }
                                                                text={
                                                                    decisionOption.text
                                                                }
                                                                answer={answer}
                                                                decisionKey={
                                                                    decisionKey
                                                                }
                                                            />
                                                        );
                                                    }
                                                )}
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </>
                            )
                        );
                    })}
            </div>
        </div>
    );
});
